import React, { createContext, useContext, useMemo, useState } from "react";

const DashboardMobileNavContext = createContext(null);

export function DashboardMobileNavProvider({ children }) {
    const [sidebarOpen, setSidebarOpen] = useState(false);
    const value = useMemo(
        () => ({ sidebarOpen, setSidebarOpen }),
        [sidebarOpen],
    );
    return (
        <DashboardMobileNavContext.Provider value={value}>
            {children}
        </DashboardMobileNavContext.Provider>
    );
}

export function useDashboardMobileNav() {
    const ctx = useContext(DashboardMobileNavContext);
    if (!ctx) {
        return { sidebarOpen: false, setSidebarOpen: () => {} };
    }
    return ctx;
}
